<template>
<router-link tag="li" v-if="router && router.name && (permissions[name[0]].includes('true'))" :to="router.name">
    <a>
      <i :class="icon"></i> <span class="name_th">{{ name_th }}</span>
      <span class="pull-right-container" style="display: inline-flex;" v-show="badge">
        <small class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
      </span>
    </a>
  </router-link>
  <li v-bind:class="[{ active: isActive }, getType]" v-else>
    <!-- {{ isHeader ? name : "" }} -->
    <a href="#" v-if="!isHeader" @click.prevent="test(name_th)">
      <i :class="icon"></i> <span>{{ name_th }}</span>
      <span class="pull-right-container">
        <!-- <small v-if="badge && badge.data" class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small> -->
        <i class="fa fa-angle-left pull-right"></i>
      </span>
    </a>
    <ul class="treeview-menu" v-if="items.length > 0">
      <li
        v-for="(item, index) in items.filter(i => permissions[i.name[0]].includes('true'))"
        :class="[item.name.includes($route.name) ? 'active' : '']"
        :data="item"
        :key="index"
      >
        <router-link :to="item.router.name">
          <!-- <router-link tag="li" v-for="(item,index) in items" :data="item" :key="index" :to="item.router" v-if="item.router"> -->
          <!-- <span><i :class="item.icon"></i> {{ item.name_th }} </span> -->
          <i :class="item.icon"></i><span class="name_th" style="width: 165px; padding-left: 15px;"> {{ item.name_th }} </span>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<style scoped>
li > a > .fa {
  top: 15px !important;
}
ul.sidebar-menu li a span.name_th {
  display: inline-flex;
}
</style>
<script>
export default {
  name: "va-slide-item",
  props: {
    // type: {
    //   type: String,
    //   default: 'item'
    // },
    isHeader: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    name: {
      type: Array,
    },
    name_th: {
      type: String,
    },
    badge: {
      type: Object,
      default() {
        return {};
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    router: {
      type: Object,
      default() {
        return {
          name: "",
        };
      },
    },
    link: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: false,
      permissions: {}
    };
  },
  created() {
    // console.log(JSON.parse(atob(this.$cookies.get("user_nbtc").permission)));
    this.permissions = JSON.parse(atob(this.$cookies.get("user_nbtc").permission))
    // console.log(this.items)
    // console.log(this.$cookies.get("user_nbtc"));
  },
  computed: {
    getType() {
      if (this.isHeader) {
        return "header";
      }
      return this.type === "item" ? "" : "treeview";
    },
  },
  methods: {
    test: function (params) {
      this.isActive == false ? this.isActive = true : this.isActive = false;
      // console.log(this.$route)
      // console.log(this.$attrs.data.items)
      // console.log(params)
    },
  },
};
</script>